const STANDARD_API_MAPPINGS = Object.freeze({
  production: 'https://api.untapped.io/api/',
  qa: 'https://api-qa.untapped.io/api/',
  develop: 'https://api-dev.untapped.io/api/',
  local: 'http://localhost:8000/api/',
})
const APP_ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT || 'production'

/**
 * This is our base API url. Anything that needs to do something different based on environment should use this to
 * determine instead of environment. May be null if the API is invalid (there's checking for this). Sets it on
 * process.env for sharing with the app itself.
 * @type {String}
 */
export const baseAPIURL = STANDARD_API_MAPPINGS[APP_ENVIRONMENT]
